import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormArray } from '@angular/forms';


@Injectable()
export class FormCheckboxService {

  buildCheckbox(formArray: UntypedFormArray, list: any, listChecked: any): void {
     const arr = [];

     list.forEach((item, i) => {
       let checked = false;
       if (listChecked) {
         checked = (listChecked.findIndex(
             itemChecked => item['@id'] === (typeof itemChecked !== 'string' ? itemChecked['@id'] : itemChecked)) !== -1);
       }
       formArray.setControl(i, new UntypedFormControl(checked));
     });
   }

   formatData(formValues: any, values: any): Array<string> {
     const checkboxes = [];

     formValues.forEach((val, i) => {
       if (val) {
         checkboxes.push(values[i]['@id']);
       }
     });

     return checkboxes;
   }

}
